var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`warp colorTheme_${_vm.themeColor}`,style:({ '--themeColor': _vm.themeColor, '--themeBtnColor': _vm.themeBtnColor })},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }